export default __webpack_public_path__ + "static/media/frank.dd1b4370.png";